import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API_URL from "../config";

export default function EditCertificate() {
  const { certId } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    student_name: "",
    email: "",
    phone: "",
    address: "",
    college: "",
    department: "",
    dob: "",
    age: "",
    internship_from: "",
    internship_to: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // 🔹 FETCH & PREFILL DATA
  useEffect(() => {
    fetch(`${API_URL}/students`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.students)) {
          const student = data.students.find(s => s.cert_id === certId);
          if (student) {
            setForm({
              student_name: student.student_name || "",
              email: student.email || "",
              phone: student.phone || "",
              address: student.address || "",
              college: student.college || "",
              department: student.department || "",
              dob: student.dob || "",
              age: student.age || "",
              internship_from: student.internship_from || "",
              internship_to: student.internship_to || "",
            });
          } else {
            setError("Certificate not found");
          }
        } else {
          setError("Certificate not found");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load certificate");
        setLoading(false);
      });
  }, [certId]);

  // 🔹 HANDLE INPUT CHANGE
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔹 UPDATE CERTIFICATE
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(
        `${API_URL}/update/${certId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const result = await res.json();
      if (result.success) {
        alert("Certificate updated successfully");
        navigate("/admin/dashboard");
      } else {
        setError("Update failed");
      }
    } catch {
      setError("Server error while updating");
    }
  };

  if (loading) {
    return (
      <div className="py-20 text-center text-slate-500">
        Loading certificate…
      </div>
    );
  }

  return (
    <div className="bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-slate-800">
              Edit Certificate
            </h1>
            <p className="text-sm text-slate-500">
              Update certificate and student information
            </p>
          </div>

          {error && (
            <p className="text-red-600 text-sm mb-4">{error}</p>
          )}

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* LEFT */}
              <div className="md:col-span-2 space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    name="student_name"
                    placeholder="Student Name"
                    value={form.student_name}
                    onChange={handleChange}
                    className="input"
                  />
                  <input
                    name="college"
                    placeholder="College"
                    value={form.college}
                    onChange={handleChange}
                    className="input"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <input
                    type="date"
                    name="dob"
                    value={form.dob}
                    onChange={handleChange}
                    className="input"
                  />
                  <input
                    name="age"
                    placeholder="Age"
                    value={form.age}
                    onChange={handleChange}
                    className="input"
                  />
                  <input
                    name="department"
                    placeholder="Department"
                    value={form.department}
                    onChange={handleChange}
                    className="input"
                  />
                </div>

                <textarea
                  name="address"
                  placeholder="Address"
                  rows="3"
                  value={form.address}
                  onChange={handleChange}
                  className="input"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    name="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={handleChange}
                    className="input"
                  />
                  <input
                    name="phone"
                    placeholder="Phone"
                    value={form.phone}
                    onChange={handleChange}
                    className="input"
                  />
                </div>

                <div>
                  <p className="text-sm font-medium text-slate-600 mb-2">
                    Internship Duration
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <input
                      type="date"
                      name="internship_from"
                      value={form.internship_from}
                      onChange={handleChange}
                      className="input"
                    />
                    <input
                      type="date"
                      name="internship_to"
                      value={form.internship_to}
                      onChange={handleChange}
                      className="input"
                    />
                  </div>
                </div>
              </div>

              {/* RIGHT (INFO CARD) */}
              <div className="space-y-4">
                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
                  <p className="font-medium mb-1">
                    Note
                  </p>
                  <p>
                    Certificate images cannot be edited after issuance.
                    Only student and internship details can be updated.
                  </p>
                </div>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="flex justify-end gap-4 mt-8">
              <button
                type="button"
                onClick={() => navigate("/admin/dashboard")}
                className="px-6 py-2.5 border border-slate-300 rounded-xl hover:bg-slate-100 transition"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="px-6 py-2.5 bg-indigo-600 text-white rounded-xl
                  hover:bg-indigo-700 transition"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
